import { HttpApi } from '../api/HttpApi';

export const getCountryAlpha2ByCountryOrCode = async (
  countryOrCode: string | null
) => {
  if (!countryOrCode) return null;

  const countryList = localStorage.getItem('country-list');
  if (countryList) {
    try {
      const parsedList = JSON.parse(countryList) as Array<{
        text: string;
        value: string;
        alpha2: string;
      }>;
      const countryOrCodeLower = countryOrCode.toLowerCase();
      const match = parsedList.find(
        item =>
          item.text?.toLowerCase() === countryOrCodeLower ||
          item.alpha2?.toLowerCase() === countryOrCodeLower
      );
      return match?.alpha2 || null;
    } catch (error) {
      console.error('Failed to parse country list from localStorage:', error);
    }
  }

  try {
    return (
      (await HttpApi.get(
        `/Misc/GetCountryAlpha2ByCountryOrCode?value=${countryOrCode}`
      )) || null
    );
  } catch (error) {
    console.error('Failed to fetch country alpha-2 code:', error);
    return null;
  }
};
